import { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  SmartphoneIcon,
  TabletIcon,
  LaptopIcon,
  WatchIcon,
  ConsoleIcon,
  PortableConsoleIcon,
  HeadphonesIcon,
} from '../../icons';
import { Section, Container, SectionTitle } from '../../ui';
import styles from './BuybackDevices.module.css';

const deviceIcons = [
  SmartphoneIcon,
  TabletIcon,
  LaptopIcon,
  WatchIcon,
  ConsoleIcon,
  PortableConsoleIcon,
  HeadphonesIcon,
];

export function BuybackDevices() {
  const { t } = useTranslation('buyback');
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const hasAnimated = useRef(false);

  const categories = t('devices.categories', { returnObjects: true }) as string[];

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Section variant="gray">
      <Container>
        <SectionTitle
          title={t('devices.title')}
          subtitle={t('devices.subtitle')}
          centered
        />
        <div ref={ref} className={`${styles.wrapper} ${isVisible ? styles.visible : ''}`}>
          <div className={styles.grid}>
            {categories.map((name, i) => {
              const Icon = deviceIcons[i];
              return (
                <div
                  key={i}
                  className={styles.card}
                  style={{ '--device-index': i } as React.CSSProperties}
                >
                  <div className={styles.iconCircle}>
                    <Icon size={28} />
                  </div>
                  <span className={styles.name}>{name}</span>
                </div>
              );
            })}
          </div>
        </div>
      </Container>
    </Section>
  );
}
